export default __webpack_public_path__ + "static/media/ep5collage1.30a36b6c.jpg";